import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Upload,
  Select,
  message,
  Row,
  Col,
  Modal,
  Checkbox,
  Steps,
} from 'antd';
import newAlert from 'src/components/newAlert';
import { useSelector, useDispatch } from 'react-redux';
import { start_loading, end_loading } from 'src/core/actions/loader';
import axios from 'src/core/utils/axios';
import { CloudUploadOutlined } from '@ant-design/icons';

const { Step } = Steps;
const { Option } = Select;

const sourceList = {
  1: 'Диамонд',
  2: 'Смарт ложик',
  3: 'Эрхэт',
  4: 'Такс',
  5: 'Даянсофт',
};

const typesList = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

const MONTHS = Array.from({ length: 12 }, (_, index) => ({
  value: index + 1,
  label: `${index + 1}-р сар`,
}));

const steps = [
  {
    title: 'Үндсэн мэдээлэл',
    content: 'basic-info',
  },
  {
    title: 'Борлуулалт',
    content: 'sales',
  },
  {
    title: 'Худалдан авалт',
    content: 'purchase',
  },
];

export const FileUpload = ({ visible = true, onCancel = () => {} }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState({
    bor: false,
    ha: false,
    bor_file_has: false,
    ha_file_has: false,
    bor_butsaalt: false,
    ha_butsaalt: false,
  });
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({});

  const { socket, data_date } = useSelector((state) => state);

  const nextStep = async () => {
    try {
      const stepData = await form.validateFields();
      setFormData((prev) => ({
        ...prev,
        ...stepData,
      }));
      setCurrentStep(currentStep + 1);
    } catch (error) {
      console.log('Validation failed:', error);
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // const onFinish = async () => {
  //   dispatch(start_loading({}));
  //   try {
  //     const finalStepData = await form.validateFields();
  //     const allFormData = {
  //       ...formData,
  //       ...finalStepData,
  //     };

  //     console.log('Complete form data:', allFormData);

  //     const uploadData = new FormData();

  //     const dataToAppend = {
  //       bor_merge_ebarimt: allFormData?.bor_merge_ebarimt || false,
  //       year: data_date?.year,
  //       month: allFormData?.month,
  //       type: allFormData?.file_type,
  //       token,
  //       borluulalt: {
  //         nehemjleh: allFormData?.nehemjleh?.[0]?.originFileObj ?? null,
  //         borluulalt: allFormData?.tolbor_barimt?.[0]?.originFileObj ?? null,
  //         nbb: allFormData?.bor_file_has
  //           ? allFormData?.bor_file?.[0]?.originFileObj
  //           : null,
  //       },
  //       hudaldan_awalt: {
  //         gaaliin_medeelel: allFormData?.ha_file_has
  //           ? allFormData?.gaali?.[0]?.originFileObj
  //           : null,
  //         ha_burtgel: allFormData?.ha_file_has
  //           ? allFormData?.ha_burtgel?.[0]?.originFileObj
  //           : null,
  //         hoishlogdson_padan: allFormData?.ha_file_has
  //           ? allFormData?.hoish_padaan?.[0]?.originFileObj
  //           : null,
  //         tolbor_barimt_jagsaalt: allFormData?.ha_file_has
  //           ? allFormData?.ha_tolbor_barimt?.[0]?.originFileObj
  //           : null,
  //         uh_tentsuuleh: allFormData?.ha_file_has
  //           ? allFormData?.huvi_tents?.[0]?.originFileObj
  //           : null,
  //       },
  //       butsaalt_hungulult: {
  //         borluulalt: allFormData?.bor_butsaalt?.[0]?.originFileObj ?? null,
  //         hudaldan_awalt: allFormData?.ha_butsaalt?.[0]?.originFileObj ?? null,
  //       },
  //     };

  //     // Add basic form data
  //     uploadData.append('bor_merge_ebarimt', dataToAppend.bor_merge_ebarimt);
  //     uploadData.append('year', dataToAppend.year);
  //     uploadData.append('month', dataToAppend.month);
  //     uploadData.append('type', dataToAppend.type);
  //     uploadData.append('token', dataToAppend.token);

  //     // Add borluulalt files
  //     if (dataToAppend.borluulalt.nbb) {
  //       uploadData.append('borluulalt[nbb]', dataToAppend.borluulalt.nbb);
  //     }
  //     if (dataToAppend.borluulalt.nehemjleh) {
  //       uploadData.append(
  //         'borluulalt[nehemjleh]',
  //         dataToAppend.borluulalt.nehemjleh
  //       );
  //     }
  //     if (dataToAppend.borluulalt.borluulalt) {
  //       uploadData.append(
  //         'borluulalt[borluulalt]',
  //         dataToAppend.borluulalt.borluulalt
  //       );
  //     }

  //     // Add hudaldan awalt files
  //     if (dataToAppend.hudaldan_awalt.gaaliin_medeelel) {
  //       uploadData.append(
  //         'hudaldan_awalt[gaaliin_medeelel]',
  //         dataToAppend.hudaldan_awalt.gaaliin_medeelel
  //       );
  //     }
  //     if (dataToAppend.hudaldan_awalt.ha_burtgel) {
  //       uploadData.append(
  //         'hudaldan_awalt[ha_burtgel]',
  //         dataToAppend.hudaldan_awalt.ha_burtgel
  //       );
  //     }
  //     if (dataToAppend.hudaldan_awalt.hoishlogdson_padan) {
  //       uploadData.append(
  //         'hudaldan_awalt[hoishlogdson_padan]',
  //         dataToAppend.hudaldan_awalt.hoishlogdson_padan
  //       );
  //     }
  //     if (dataToAppend.hudaldan_awalt.tolbor_barimt_jagsaalt) {
  //       uploadData.append(
  //         'hudaldan_awalt[tolbor_barimt_jagsaalt]',
  //         dataToAppend.hudaldan_awalt.tolbor_barimt_jagsaalt
  //       );
  //     }
  //     if (dataToAppend.hudaldan_awalt.uh_tentsuuleh) {
  //       uploadData.append(
  //         'hudaldan_awalt[uh_tentsuuleh]',
  //         dataToAppend.hudaldan_awalt.uh_tentsuuleh
  //       );
  //     }

  //     // Add butsaalt files
  //     if (dataToAppend.butsaalt_hungulult.borluulalt) {
  //       uploadData.append(
  //         'butsaalt_hungulult[borluulalt]',
  //         dataToAppend.butsaalt_hungulult.borluulalt
  //       );
  //     }
  //     if (dataToAppend.butsaalt_hungulult.hudaldan_awalt) {
  //       uploadData.append(
  //         'butsaalt_hungulult[hudaldan_awalt]',
  //         dataToAppend.butsaalt_hungulult.hudaldan_awalt
  //       );
  //     }

  //     // Log FormData contents
  //     console.log('FormData contents:');
  //     for (const pair of uploadData.entries()) {
  //       console.log(pair[0], pair[1]);
  //     }

  //     const { status, key } = await axios.post(
  //       'noat',
  //       '/request_web',
  //       uploadData,
  //       {
  //         'Content-Type': 'multipart/form-data',
  //       }
  //     );

  //     if (status === '0') {
  //       newAlert({
  //         type: 'success',
  //         msg: 'Тооцоолол эхэллээ та түр хүлээнэ үү',
  //       });
  //       onCancel();
  //       form.resetFields();
  //       setFormData({});
  //     } else {
  //       newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
  //     }
  //   } catch (error) {
  //     console.error('Error details:', error);
  //     newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
  //   } finally {
  //     dispatch(end_loading({}));
  //   }
  // };

  const onFinish = async () => {
    console.log('====================>', localStorage.getItem('noat_token'));

    dispatch(start_loading({}));
    try {
      const finalStepData = await form.validateFields();
      const allFormData = {
        ...formData,
        ...finalStepData,
      };

      // Debug log to check form data
      console.log('Form Data:', allFormData);
      console.log('HA file has:', allFormData.ha_file_has);
      console.log('HA files:', {
        burtgel: allFormData?.ha_burtgel?.[0]?.originFileObj,
        gaali: allFormData?.gaali?.[0]?.originFileObj,
        huvi_tents: allFormData?.huvi_tents?.[0]?.originFileObj,
        hoish_padaan: allFormData?.hoish_padaan?.[0]?.originFileObj,
        ha_tolbor_barimt: allFormData?.ha_tolbor_barimt?.[0]?.originFileObj,
      });

      const uploadData = new FormData();
      // wtf
      // Basic form data
      uploadData.append(
        'bor_merge_ebarimt',
        allFormData.bor_merge_ebarimt || false
      );
      // test
      uploadData.append('year', data_date?.year);
      uploadData.append('month', allFormData.month);
      uploadData.append('type', allFormData.file_type);
      uploadData.append('token', localStorage.getItem('noat_token'));

      // Handle borluulalt files
      if (allFormData.bor_file_has) {
        if (allFormData?.bor_file?.[0]?.originFileObj) {
          uploadData.append(
            'borluulalt[nbb]',
            allFormData.bor_file[0].originFileObj
          );
        }
        if (allFormData?.nehemjleh?.[0]?.originFileObj) {
          uploadData.append(
            'borluulalt[nehemjleh]',
            allFormData.nehemjleh[0].originFileObj
          );
        }
        if (allFormData?.tolbor_barimt?.[0]?.originFileObj) {
          uploadData.append(
            'borluulalt[borluulalt]',
            allFormData.tolbor_barimt[0].originFileObj
          );
        }
      }

      // Handle hudaldan_awalt files
      if (allFormData.ha_file_has) {
        if (allFormData?.ha_burtgel?.[0]?.originFileObj) {
          uploadData.append(
            'hudaldan_awalt[ha_burtgel]',
            allFormData.ha_burtgel[0].originFileObj
          );
        }
        if (allFormData?.gaali?.[0]?.originFileObj) {
          uploadData.append(
            'hudaldan_awalt[gaaliin_medeelel]',
            allFormData.gaali[0].originFileObj
          );
        }
        if (allFormData?.huvi_tents?.[0]?.originFileObj) {
          uploadData.append(
            'hudaldan_awalt[uh_tentsuuleh]',
            allFormData.huvi_tents[0].originFileObj
          );
        }
        if (allFormData?.hoish_padaan?.[0]?.originFileObj) {
          uploadData.append(
            'hudaldan_awalt[hoishlogdson_padan]',
            allFormData.hoish_padaan[0].originFileObj
          );
        }
        if (allFormData?.ha_tolbor_barimt?.[0]?.originFileObj) {
          uploadData.append(
            'hudaldan_awalt[tolbor_barimt_jagsaalt]',
            allFormData.ha_tolbor_barimt[0].originFileObj
          );
        }
      }

      // Debug log to check FormData
      for (const pair of uploadData.entries()) {
        console.log(pair[0], pair[1]);
      }

      // Rest of your code...
      const headers = {
        'Content-Type': 'multipart/form-data',
        jwt: localStorage.getItem('taxjwt'),
      };

      const { status, key } = await axios.post(
        'noat',
        '/request_web',
        uploadData,
        headers
      );

      if (status === '0') {
        newAlert({
          type: 'success',
          msg: 'Тооцоолол эхэллээ та түр хүлээнэ үү',
        });
        onCancel();
        form.resetFields();
        setFormData({});
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
    } catch (error) {
      console.error('Error details:', error);
      newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
    } finally {
      dispatch(end_loading({}));
    }
  };

  const handleMonthSelectAll = (selected) => {
    const allMonths = MONTHS.map((month) => month.value);
    form.setFieldsValue({ month: selected ? allMonths : [] });
  };

  const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);

  const handleFormChange = () => {
    const formValues = form.getFieldsValue();
    console.log('Form values changed:', formValues); // Debug log
    setFileList({
      bor: formValues.bor_file?.length > 0,
      ha: formValues.ha_file?.length > 0,
      bor_file_has: formValues.bor_file_has,
      ha_file_has: formValues.ha_file_has,
      bor_butsaalt: formValues.bor_butsaalt?.length > 0,
      ha_butsaalt: formValues.ha_butsaalt?.length > 0,
    });
  };

  const handleBeforeUpload = (file) => {
    const isValidFileType = typesList.includes(file.type);
    const isFileSizeValid = file.size / 1024 / 1024 < 15;

    if (!isValidFileType) {
      message.error(`${file.name} файл excel форматаар байх шаардлагатай`);
    } else if (!isFileSizeValid) {
      message.error(`${file.name} 15MB-аас доош хэмжээтэй байх шаардлагатай`);
    }

    return isValidFileType && isFileSizeValid;
  };
  const renderUploadField = (
    name,
    label,
    disabled = false,
    required = false
  ) => (
    <Form.Item
      name={name}
      label={label}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      rules={[{ required, message: 'Файл сонгоно уу' }]}
    >
      <Upload.Dragger
        disabled={disabled}
        accept={typesList.join()}
        showUploadList
        maxCount={1}
        beforeUpload={(file) => {
          const isValid = handleBeforeUpload(file);
          return isValid ? false : Upload.LIST_IGNORE; // Return false to prevent auto upload
        }}
      >
        <p className="ant-upload-drag-icon">
          <CloudUploadOutlined />
        </p>
        <p className="ant-upload-text">{label}</p>
        <p className="ant-upload-hint">
          Click or drag file to this area to upload
        </p>
      </Upload.Dragger>
    </Form.Item>
  );

  const renderBasicInfo = () => (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item
          name="month"
          label="Сар"
          rules={[{ required: true, message: 'Сар сонгоно уу' }]}
          extra={
            <Button
              type="link"
              onClick={() =>
                handleMonthSelectAll(form.getFieldValue('month')?.length !== 12)
              }
              style={{ padding: 0 }}
            >
              {form.getFieldValue('month')?.length === 12
                ? 'Бүгдийг цуцлах'
                : 'Бүгдийг сонгох'}
            </Button>
          }
        >
          <Select
            mode="multiple"
            placeholder="Сар сонгоно уу"
            style={{ width: '100%' }}
            options={MONTHS}
            maxTagCount="responsive"
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          name="file_type"
          label="Файлын төрөл"
          rules={[{ required: true, message: 'Файлын төрөл сонгоно уу' }]}
        >
          <Select showSearch>
            {Object.entries(sourceList).map(([key, value]) => (
              <Option key={key} value={parseInt(key)}>
                {value}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );

  const renderSalesInfo = () => (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item name="bor_file_has" valuePropName="checked">
          <Checkbox>Борлуулалт</Checkbox>
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          name="bor_merge_ebarimt"
          valuePropName="checked"
          initialValue={false}
        >
          <Checkbox disabled={!fileList.bor_file_has}>
            Борлуулалтын и-баримт нэгтгэх
          </Checkbox>
        </Form.Item>
      </Col>

      <Col span={12}>
        {renderUploadField(
          'bor_file',
          'Борлуулалтын файл',
          !fileList.bor_file_has,
          fileList.bor_file_has
        )}
      </Col>

      <Col span={12}>
        {renderUploadField(
          'nehemjleh',
          'Нэмэгдэл төлбөрийн падаан',
          !fileList.bor_file_has
        )}
      </Col>

      <Col span={12}>
        {renderUploadField(
          'tolbor_barimt',
          'Төлбөрийн баримт',
          !fileList.bor_file_has
        )}
      </Col>

      <Col span={12}>
        {renderUploadField(
          'bor_butsaalt',
          'Борлуулалтын буцаалт',
          !fileList.bor_file_has
        )}
      </Col>
    </Row>
  );

  const renderPurchaseInfo = () => (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item name="ha_file_has" valuePropName="checked">
          <Checkbox>Худалдан авалт</Checkbox>
        </Form.Item>
      </Col>

      <Col span={12}>
        {renderUploadField(
          'ha_burtgel',
          'Худалдан авалтын бүртгэл',
          !fileList.ha_file_has,
          fileList.ha_file_has
        )}
      </Col>

      <Col span={12}>
        {renderUploadField('gaali', 'Гаалийн мэдүүлэг', !fileList.ha_file_has)}
      </Col>

      <Col span={12}>
        {renderUploadField(
          'huvi_tents',
          'Хувь тэнцүүлэн хасах падаанаас хэрэгжүүлсэн',
          !fileList.ha_file_has
        )}
      </Col>

      <Col span={12}>
        {renderUploadField(
          'hoish_padaan',
          'Хойшлогдсон падаанаас хэрэгжүүлсэн',
          !fileList.ha_file_has
        )}
      </Col>

      <Col span={12}>
        {renderUploadField(
          'ha_tolbor_barimt',
          'Төлбөрийн баримтаар шивсэн',
          !fileList.ha_file_has
        )}
      </Col>

      <Col span={12}>
        {renderUploadField(
          'ha_butsaalt',
          'Худалдан авалтын буцаалт',
          !fileList.ha_file_has
        )}
      </Col>
    </Row>
  );

  const renderStepContent = () => {
    switch (steps[currentStep].content) {
      case 'basic-info':
        return renderBasicInfo();
      case 'sales':
        return renderSalesInfo();
      case 'purchase':
        return renderPurchaseInfo();
      default:
        return null;
    }
  };

  return (
    <Modal
      visible={visible}
      className="file-upload-form"
      title="Файл оруулах"
      footer={null}
      onCancel={onCancel}
      destroyOnClose
      maskClosable={false}
      width={800}
    >
      <Steps current={currentStep}>
        {steps.map((step) => (
          <Step key={step.title} title={step.title} />
        ))}
      </Steps>
      <div className="mt-8">
        <Form
          form={form}
          layout="vertical"
          className="file-upload-form"
          onFieldsChange={handleFormChange}
        >
          {renderStepContent()}

          <div className="flex gap-2 mt-6">
            {currentStep > 0 && (
              <Button
                onClick={prevStep}
                className="bg-gray-100 text-gray-600 hover:bg-gray-200"
                type="default"
              >
                Өмнөх
              </Button>
            )}
            <Button
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
              className="bg-gray-100 text-gray-600 hover:bg-gray-200"
              type="default"
            >
              Цуцлах
            </Button>
            {currentStep < steps.length - 1 ? (
              <Button type="primary" onClick={nextStep} className="bg-blue-500">
                Дараах
              </Button>
            ) : (
              <Button
                type="primary"
                onClick={onFinish}
                className="bg-blue-500"
                disabled={!fileList.ha_file_has && !fileList.bor_file_has}
              >
                Хадгалах
              </Button>
            )}
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default FileUpload;
